import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { EyeOff, Eye, ChevronDown, Settings2 } from "lucide-react";

const SOORT_LABEL = { categorie: "categorie", subgroep: "subgroep", item: "pagina" };

/** Onderaan het menu: alles wat de gebruiker zelf verborgen heeft — nog steeds te openen, en met één klik weer terug te zetten. */
export function VerborgenMenu({ verborgen, onHerstel, onInstellingen }) {
  const [open, setOpen] = useState(false);
  if (!verborgen.length) return null;
  return (
    <div className="mt-2 pt-2 border-t border-dashed border-slate-200" data-testid="verborgen-menu">
      <button onClick={(e) => { e.stopPropagation(); setOpen((o) => !o); }} data-testid="verborgen-menu-toggle"
        className="w-full flex items-center gap-2 px-3 py-2 text-[11px] font-bold uppercase tracking-wider rounded-md text-slate-500 bg-slate-50 hover:bg-slate-100 hover:text-slate-800 transition-colors">
        <EyeOff className="h-3.5 w-3.5" />
        <span className="flex-1 text-left">Verborgen onderdelen</span>
        <span className="text-[10px] font-semibold px-1.5 py-0.5 rounded-full bg-slate-200 text-slate-700" data-testid="verborgen-menu-aantal">{verborgen.length}</span>
        <ChevronDown className={`h-3.5 w-3.5 transition-transform ${open ? "" : "-rotate-90"}`} />
      </button>
      {open && (
        <div className="space-y-1 mt-1" onClick={(e) => e.stopPropagation()}>
          {verborgen.map((v) => <VerborgenBlok key={`${v.soort}-${v.key}`} v={v} onHerstel={onHerstel} />)}
          <button onClick={onInstellingen} className="w-full flex items-center gap-2 pl-8 pr-3 py-1.5 text-xs text-slate-500 hover:text-slate-800" data-testid="verborgen-menu-instellingen">
            <Settings2 className="h-3.5 w-3.5" /> Menu aanpassen…
          </button>
        </div>
      )}
    </div>
  );
}

function VerborgenBlok({ v, onHerstel }) {
  const Icon = v.icon || EyeOff;
  const enkel = v.soort === "item";
  return (
    <div className="rounded-md bg-slate-50/70" data-testid={`verborgen-${v.soort}-${v.key}`}>
      <div className="flex items-center gap-2 pl-5 pr-2 py-1.5">
        {enkel ? (
          <NavLink to={v.items[0].to} className="flex-1 flex items-center gap-2 min-w-0 text-sm text-slate-500 hover:text-slate-800" data-testid={`verborgen-link-${v.items[0].tid}`}>
            <Icon className="h-4 w-4 shrink-0" /><span className="truncate">{v.label}</span>
          </NavLink>
        ) : (
          <span className="flex-1 flex items-center gap-2 min-w-0 text-[10px] uppercase tracking-wider font-semibold text-slate-500">
            <Icon className="h-3.5 w-3.5 shrink-0" /><span className="truncate">{v.label}</span>
          </span>
        )}
        <button onClick={() => onHerstel(v.soort, v.key)} title={`Deze ${SOORT_LABEL[v.soort]} weer tonen in het menu`} aria-label="Weer tonen"
          className="p-1 text-slate-400 hover:text-emerald-600" data-testid={`verborgen-herstel-${v.soort}-${v.key}`}>
          <Eye className="h-3.5 w-3.5" />
        </button>
      </div>
      {!enkel && (
        <div className="pb-1">
          {v.items.map((it) => {
            const I = it.icon;
            return (
              <NavLink key={it.to + it.label} to={it.to} data-testid={`verborgen-link-${it.tid}`}
                className="flex items-center gap-2 pl-10 pr-3 py-1 text-[13px] text-slate-500 hover:text-slate-800 hover:bg-slate-100 rounded-md">
                <I className="h-3.5 w-3.5" /><span className="truncate">{it.label}</span>
              </NavLink>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default VerborgenMenu;
